const CENTER_X = 100
const CENTER_Y = 100
const OUTER_RADIUS = 92
const INNER_RADIUS = 60
const NEEDLE_LENGTH = 74
const SEGMENT_GAP_DEGREES = 1.5

const LOWEST_SCORE = 1
const HIGHEST_SCORE = 5
const SEGMENT_DEGREES = 180 / HIGHEST_SCORE

const point = (degrees: number, radius: number) => {
  const radians = (degrees * Math.PI) / 180
  return {
    x: Number((CENTER_X + radius * Math.cos(radians)).toFixed(2)),
    y: Number((CENTER_Y - radius * Math.sin(radians)).toFixed(2)),
  }
}

const coordinates = (degrees: number, radius: number) => {
  const { x, y } = point(degrees, radius)
  return `${x} ${y}`
}

export const GAUGE_CENTER = { x: CENTER_X, y: CENTER_Y }

// Score 1 starts on the left, score 5 ends on the right; a small gap separates the segments.
export const segmentPath = (index: number) => {
  const start = 180 - index * SEGMENT_DEGREES - (index === 0 ? 0 : SEGMENT_GAP_DEGREES / 2)
  const end = 180 - (index + 1) * SEGMENT_DEGREES + (index === HIGHEST_SCORE - 1 ? 0 : SEGMENT_GAP_DEGREES / 2)

  return [
    `M ${coordinates(start, OUTER_RADIUS)}`,
    `A ${OUTER_RADIUS} ${OUTER_RADIUS} 0 0 1 ${coordinates(end, OUTER_RADIUS)}`,
    `L ${coordinates(end, INNER_RADIUS)}`,
    `A ${INNER_RADIUS} ${INNER_RADIUS} 0 0 0 ${coordinates(start, INNER_RADIUS)}`,
    'Z',
  ].join(' ')
}

export const needleTip = (average: number) => {
  const clamped = Math.min(Math.max(average, LOWEST_SCORE), HIGHEST_SCORE)
  const degrees = 180 - ((clamped - LOWEST_SCORE) / (HIGHEST_SCORE - LOWEST_SCORE)) * 180
  return point(degrees, NEEDLE_LENGTH)
}
